// tslint:disable: variable-name
export default class RecordingDetail {
    id: number;
    lr_tg: number;
    lessor_name: string;
    document_type: string;
    req_no: string;
    short_legal: string;
    no_pages?: number;
    amount?: number;
}


// WEBPACK FOOTER //
// ./src/models/dlcLease/RecordingDetail.ts